import { ReactNode, useEffect } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { I18nextProvider } from 'react-i18next';
import { ThemeProvider } from '@mui/material/styles';
import { ThemeProvider as LegacyThemeProvider } from '@mui/styles';
import AlertMessageFloat from '@antecipa/core/components/alert-message-float';
import {
  GlobalProvider,
  useGlobalState,
  MessageProvider,
} from '@antecipa/core/contexts';
import {
  getWhiteLabelConfig,
  WhiteLabelProvider,
} from '@antecipa/core/hooks/useWhiteLabel';
import { lightTheme, darkTheme } from '@antecipa/core/style/theme';

import { AppRoute } from 'application/routes/AppRoute';
import { ServicesProvider } from 'application/services/services.context';
import i18n from 'presentation/i18n/i18n';

function ThemeWrapper({ children }: { children: ReactNode }) {
  const { themeMode } = useGlobalState();
  const currentTheme = themeMode === 'dark' ? darkTheme : lightTheme;
  return (
    <ThemeProvider theme={currentTheme}>
      <LegacyThemeProvider theme={currentTheme}>{children}</LegacyThemeProvider>
    </ThemeProvider>
  );
}

export function Startup() {
  useEffect(() => {
    const whiteLabelConfig = getWhiteLabelConfig();

    document.title = `${whiteLabelConfig.platformName} - Autenticação de Usuário`;

    let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = `/${whiteLabelConfig.faviconAssetName}`;
  }, []);

  return (
    <GlobalProvider>
      <ThemeWrapper>
        <I18nextProvider i18n={i18n}>
          <WhiteLabelProvider>
            <GoogleReCaptchaProvider
              reCaptchaKey={import.meta.env.VITE_RECAPTCHA_KEY_V3}
            >
              <MessageProvider>
                <ServicesProvider>
                  <AppRoute />
                </ServicesProvider>
                <AlertMessageFloat />
              </MessageProvider>
            </GoogleReCaptchaProvider>
          </WhiteLabelProvider>
        </I18nextProvider>
      </ThemeWrapper>
    </GlobalProvider>
  );
}
